import type { IconSvgObject } from './types';

const Redo03Icon: IconSvgObject = [
  ["path", { d: "M21 8H9C5.68629 8 3 10.6863 3 14C3 17.3137 5.68629 20 9 20H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 4L18.1538 4.87652C20.0513 6.31801 21 7.03875 21 8C21 8.96125 20.0513 9.68199 18.1538 11.1235L17 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default Redo03Icon;
